import { Button, IconMinusCircle, Wrapper } from '@screentone/core';

import { ReadOnlyTooltip } from 'components/context-menu-actions/shared/ReadOnlyTooltip';
import { useDataModelContext } from 'contexts/datamodel/useDataModel';

interface ClearItemsProps {
  hierarchyId: string;
  label: string;
  disabled?: boolean;
}

interface ClearItemsExtraProperties extends ClearItemsProps {
  postAction?: () => void;
}

export const ClearItems = ({
  hierarchyId,
  label,
  disabled = false,
  postAction = () => {}
}: ClearItemsExtraProperties) => {
  const { clearModule } = useDataModelContext();

  const handleClearItems = () => {
    clearModule(hierarchyId);
    postAction();
  };

  return (
    <Wrapper>
      <ReadOnlyTooltip disabled={disabled}>
        <Button
          tertiary
          icon={IconMinusCircle}
          color="lava"
          data-testid="clear-items-button"
          onClick={handleClearItems}
          disabled={disabled}
        >
          {label}
        </Button>
      </ReadOnlyTooltip>
    </Wrapper>
  );
};
